/**
 * Hideable report-table columns (column show/hide).
 *
 * Single source of truth for which report-table columns the user can toggle. The
 * `id`s MUST match the `isHidden(id)` gates + hide buttons in ReportTableView. The
 * Report (name) and Actions columns are intentionally PINNED — not listed here, so
 * they can never be hidden. The shared show/hide primitives live in
 * ../shared/columnVisibility.
 */
import type { HideableColumn } from "../shared/columnVisibility";

export const REPORT_HIDEABLE_COLUMNS: HideableColumn[] = [
  { id: "client", label: "Client" },
  { id: "status", label: "Status" },
  { id: "dateRange", label: "Date Range" },
  { id: "format", label: "Format" },
  { id: "updated", label: "Updated" },
  { id: "created", label: "Created" },
];
